import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MobileWebDetectorService {
  constructor(@Inject(PLATFORM_ID) private platformId: unknown) {}

  public isMobileBrowser(): boolean {
    return this.isAndroid() || this.isIOS();
  }

  public isIOS(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    const ua = navigator.userAgent;
    const isIPadOS = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
    return /iPhone|iPad|iPod/i.test(ua) || isIPadOS;
  }

  public isAndroid(): boolean {
    return isPlatformBrowser(this.platformId) && /Android/i.test(navigator.userAgent);
  }

  public isInsideAppWebView(): boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return false;
    }
    return !!window.ReactNativeWebView || new URLSearchParams(window.location.search).get('mobile') === 'true';
  }

  public isImpersonateWindow(): boolean {
    return isPlatformBrowser(this.platformId) && window.name === 'impersonateWindow';
  }

  public isMobileWebOutsideApp(): boolean {
    return this.isMobileBrowser() && !this.isInsideAppWebView() && !this.isImpersonateWindow();
  }
}
